export default {
      id: "i-service-bonds-usage",
      viewBox: "0 0 115 109",
      url: __webpack_public_path__ + "img/sprite.svg#i-service-bonds",
      toString: function () {
        return this.url;
      }
    }